import { getImageSrc } from '@isoapp/common/platform/image-optimization/getImageSrc'

// oxlint-disable-next-line no-default-export -- needed for next
export default getImageSrc
